/**
 * Normalize Firestore Timestamp, API ISO strings, and Date values to a JS Date.
 */
import moment from 'moment';
import 'moment/locale/tr';

export const toJsDate = (value) => {
  if (value == null) return null;
  if (value instanceof Date) return value;
  if (typeof value.toDate === 'function') return value.toDate();
  if (typeof value === 'string' || typeof value === 'number') {
    const d = new Date(value);
    return Number.isNaN(d.getTime()) ? null : d;
  }
  if (typeof value === 'object') {
    const sec = value.seconds ?? value._seconds;
    if (sec != null) {
      const ns = value.nanoseconds ?? value._nanoseconds ?? 0;
      return new Date(sec * 1000 + ns / 1e6);
    }
    // Bos object ({}) moment'te "bugun" olur; tarih degil
    return null;
  }
  return null;
};

export const formatDateValue = (value, format = 'DD/MM/YY / HH:mm', locale) => {
  const d = toJsDate(value);
  if (!d) return 'N/A';
  const m = moment(d);
  if (locale) {
    m.locale(locale);
  }
  return m.format(format);
};
